import { InjectionToken } from '@angular/core';

/**
 * @whatItDoes å®ä¹è·¯ç±è½¬å£°å¨ç»çå¸§æ°
 *
 * ä½ å¯ä»¥éè¿ provide èªå®ä¹å¸§æ°ï¼å¸§æ°è¶å¤ï¼è½¬åºå¨ç»çæ¶é´è¶é¿
 *
 * @howToUse
 * ```typescript
 * import { NgModule } from '@angular/core';
 * import { UI_ROUTER_ANIMATION_STEPS } from '@tanbo/ui-native';
 *
 * @NgModule({
 *   ...
 *   providers: [{
 *     provide: UI_ROUTER_ANIMATION_STEPS,
 *     useValue: 30
 *   }]
 * })
 * export class AppModule {
 * }
 * ```
 */
export const UI_ROUTER_ANIMATION_STEPS = new InjectionToken<number>('UI_ROUTER_ANIMATION_STEPS');

/**
 * @whatItDoes å®ä¹ ui-back ç»ä»¶å·¦ç®­å¤´ç html class çå¼
 *
 * ä½ å¯ä»¥éè¿ provide å®ä¹èªå·±ç class
 *
 * @howToUse
 * ```typescript
 * import { NgModule } from '@angular/core';
 * import { UI_BACK_ICON_CLASSNAME } from '@tanbo/ui-native';
 *
 * @NgModule({
 *   ...
 *   providers: [{
 *     provide: UI_BACK_ICON_CLASSNAME,
 *     useValue: 'custom-classname'
 *   }]
 * })
 * export class AppModule {
 * }
 * ```
 */
export const UI_BACK_ICON_CLASSNAME = new InjectionToken<string>('UI_BACK_ICON_CLASSNAME');